export default __webpack_public_path__ + "static/media/king.91dae69e.png";